module.exports = __webpack_public_path__ + "media/images/room_menu_icon/sales_amount_by_machines-ec1e23b49b7c24f94dff4c0b5246fdbc.png";